<template>
    <div>
        <BRow class="mb-3">
            <BCol md="12">
                 <div class="d-flex justify-content-end align-items-center mb-3">
                     <BButton variant="outline-primary" size="sm" @click="openModal">
                        <i class="fas fa-plus"></i> Add Hotel Cost
                    </BButton>
                </div>
                
                <BTableSimple hover small responsive bordered striped>
                    <BThead head-variant="light">
                        <BTr>
                            <BTh>PO No.</BTh>
                            <BTh>Hotel Name</BTh>
                            <BTh>Date</BTh>
                            <BTh class="text-end">Amount</BTh>
                            <BTh class="text-center" style="width: 100px">Action</BTh>
                        </BTr>
                    </BThead>
                    <BTbody>
                        <BTr v-for="(item, index) in form.hotel_fees" :key="index">
                            <BTd>{{ item.purchase_order_no }}</BTd>
                            <BTd>{{ item.hotel_name }}</BTd>
                            <BTd>{{ item.date }}</BTd>
                            <BTd class="text-end">{{ formatCurrency(item.amount) }}</BTd>
                             <BTd class="text-center">
                                <BButton variant="warning" size="sm" class="me-1" @click="editItem(index)"><i class="fas fa-edit"></i></BButton>
                                <BButton variant="danger" size="sm" @click="removeItem(index)"><i class="fas fa-trash"></i></BButton>
                            </BTd>
                        </BTr>
                        <BTr v-if="form.hotel_fees.length === 0">
                            <BTd colspan="5" class="text-center text-muted">No hotel fees added.</BTd>
                        </BTr>
                    </BTbody>
                     <BTfoot>
                        <BTr>
                            <BTh colspan="3" class="text-end">Total Hotel Fee</BTh>
                            <BTh class="text-end">{{ formatCurrency(total) }}</BTh>
                            <BTh></BTh>
                        </BTr>
                    </BTfoot>
                </BTableSimple>
            </BCol>
        </BRow>

        <!-- Component Form -->
        <HotelFeeForm v-if="modalVisible"
            :modal="modalVisible" 
            @update:modal="modalVisible = $event"
            :selected-data="selectedItem" 
            @add-or-update="handleSave" 
        />
    </div>
</template>

<script setup>
import { inject, computed, ref } from "vue";
import { BRow, BCol, BButton, BTableSimple, BThead, BTbody, BTfoot, BTr, BTh, BTd } from "bootstrap-vue-next";
import HotelFeeForm from "../HotelFeeForm.vue";

const form = inject('form');
const modalVisible = ref(false);
const editIndex = ref(-1);
const selectedItem = ref(null);

const openModal = () => {
    editIndex.value = -1;
    selectedItem.value = null;
    modalVisible.value = true;
};

const editItem = (index) => {
    editIndex.value = index;
    selectedItem.value = { ...form.hotel_fees[index], index };
    modalVisible.value = true;
};

const handleSave = (payload) => {
    if (editIndex.value === -1) {
        form.hotel_fees.push(payload);
    } else {
        form.hotel_fees[editIndex.value] = payload;
    }
    modalVisible.value = false;
};

const removeItem = (index) => {
    form.hotel_fees.splice(index, 1);
};

const total = computed(() => {
    return form.hotel_fees.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
});

const formatCurrency = (val) => {
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(val);
};
</script>
